import { NotfoundPage } from './view';

export default NotfoundPage;
